<div #wrapper class="view-recipe-wrapper">
    <app-modal-header [text]="'Създаване на поръчки за кетъринг'" [bold]="true" (close)="bsModalRef.hide()"></app-modal-header>

    <div class="modal-body" [ngClass]="isIOS() === true ? 'ios' : ''">
        <h2 class="title-bg">{{ 'days_to_order' | localise }}</h2>

        <ul class="dates">
            <li *ngFor="let date of dates; let i = index">
                <div class="form-group">
                    <div class="form-check">
                        <label class="form-check-label">
                            <input
                                    class="form-check-input"
                                    name="date"
                                    type="checkbox"
                                    (click)="markDayAsSelected(date.date)"
                                    value="">
                            {{ date.date }} ({{ date.week_name }})
                            <i class="input-helper"></i>
                        </label>
                    </div>
                </div>
            </li>
        </ul>

        <input class="form-control" type="text" [(ngModel)]="address" placeholder="Адрес"/>
        <input style="margin-top: 10px" class="form-control" type="text" [(ngModel)]="phone" placeholder="Телефон"/>

        <ng-container *ngIf="dates.length > 0">
            <ng-container *ngFor="let item of mealsComponent.currentlySelectedDailyMeal.meals">
                <label style="width: 100%; margin: 7px 0;" class="form-check-label">
                    <input class="checkbox"
                           type="checkbox"
                           (change)="checkMeal($event, item)">
                    {{  item.title }}
                    <i class="input-helper"></i>
                </label>
            </ng-container>
        </ng-container>

        <textarea style="margin-top: 10px" class="form-control" placeholder="Бележка ..." name="textarea" [(ngModel)]="note"></textarea>
    </div>

    <div class="modal-footer" [ngClass]="isIOS() === true ? 'ios' : ''">
        <button type="button" class="btn btn-secondary" (click)="bsModalRef.hide()">{{ 'back' | localise }}</button>
        <button type="button" class="btn btn-success" (click)="copyRecipe()">{{ 'make_order' | localise }}</button>
    </div>
</div>
